import type { CatalogTheme } from '@/fo/util/theme';

import { Locale } from '../types';
import { formattedPrice } from '../utils/formattedPrice';

import { styles } from './UiKitPriceBase.styles';

export interface UiKitPriceBaseProps {
  value: number;
  oldValue?: number | null;
  className?: string;
  classNameValue?: string;
  classNameOldValue?: string;
  locale?: Locale;
  currency?: string;
  theme?: CatalogTheme;
}

/**
 * Стилизация для цен и для обертки предается через пропсы (className, classNameValue, classNameOldValue)
 *
 * Из-за большой вариантивности шрифтов и расположения цен в макетах
 */
export function UiKitPriceBase({
  value,
  oldValue,
  className,
  classNameValue,
  classNameOldValue,
  currency,
  theme = 'default',
  ...props
}: UiKitPriceBaseProps) {
  const slots = styles({ theme });

  const formattedValue = formattedPrice(value, currency);
  const formattedOldValue = oldValue
    ? formattedPrice(oldValue, currency)
    : null;

  return (
    <span
      className={slots.base({ className: className })}
      {...props}
    >
      <span className={slots.price({ className: classNameValue })}>
        {formattedValue}
      </span>

      {formattedOldValue && formattedValue !== formattedOldValue && (
        <span className={slots.oldPrice({ className: classNameOldValue })}>
          {formattedOldValue}
        </span>
      )}
    </span>
  );
}
